/**
 * Public (storefront) Pack Builder query options. Read-only: no cart, checkout
 * or inventory writes happen anywhere in this layer.
 */
import { queryOptions } from "@tanstack/react-query";
import { getPackBySlugFn, listPackProductsFn, listPacksFn } from "./packs.functions";
import type { PackProductFilters, PackSort } from "./types";

export const publicPacksQuery = () =>
  queryOptions({
    queryKey: ["packs", "list"],
    queryFn: () => listPacksFn(),
    staleTime: 60_000,
  });

export const publicPackQuery = (slug: string) =>
  queryOptions({
    queryKey: ["packs", "detail", slug],
    queryFn: () => getPackBySlugFn({ data: { slug } }),
    staleTime: 60_000,
  });

export type PackProductQueryArgs = PackProductFilters & {
  packSlug: string;
  sort: PackSort;
  page: number;
  pageSize: number;
};

export const packProductsQuery = (args: PackProductQueryArgs) =>
  queryOptions({
    queryKey: ["packs", "products", args],
    queryFn: () =>
      listPackProductsFn({
        data: {
          packSlug: args.packSlug,
          sort: args.sort,
          page: args.page,
          pageSize: args.pageSize,
          ...(args.search?.trim() ? { search: args.search.trim() } : {}),
          ...(args.family ? { family: args.family } : {}),
          ...(args.collectionId ? { collectionId: args.collectionId } : {}),
          availability: args.availability ?? "all",
          ...(typeof args.minPrice === "number" ? { minPrice: args.minPrice } : {}),
          ...(typeof args.maxPrice === "number" ? { maxPrice: args.maxPrice } : {}),
        },
      }),
    staleTime: 30_000,
  });